module.exports = __webpack_public_path__ + "img/f74251f.png";